import { trapFocus } from "./accessibility/trapFocus.js";
import { isScreenZoomed } from "./accessibility/isScreenZoomed.js";
import { isPreferredReducedMotion } from "./accessibility/isPreferredReducedMotion.js";
import { imageHasAlt } from "./accessibility/imageHasAlt.js";
import { toUMDElement } from "./adapters/toUMDElement.js";
import { toElementVisual } from "./adapters/toElementVisual.js";
import { shrinkThenRemove } from "./animation/shrinkThenRemove.js";
import { smoothScrollToElement } from "./animation/smoothScrollToElement.js";
import { wrapLinkForAnimation } from "./animation/wrapLinkForAnimation.js";
import { observeGridAnimations } from "./animation/observeGridAnimations.js";
import { formatDateForDisplay } from "./date/formatDateForDisplay.js";
import { formatDateForComparison } from "./date/formatDateForComparison.js";
import { parseDateFromElement } from "./date/parseDateFromElement.js";
import { createEventDetails } from "./date/createEventDetails.js";
import { addClass } from "./dom/addClass.js";
import { cloneElementWithoutAttributes } from "./dom/cloneElementWithoutAttributes.js";
import { findParent } from "./dom/findParent.js";
import { extractIconElement } from "./dom/extractIconElement.js";
import { getImageFromSlot } from "./dom/getImageFromSlot.js";
import { getLinkFromSlot } from "./dom/getLinkFromSlot.js";
import { removeClass } from "./dom/removeClass.js";
import { wrapTextNodeInSpan } from "./dom/wrapTextNodeInSpan.js";
import { createImageOrLinkedImage } from "./elements/createImageOrLinkedImage.js";
import { createLinkWithSpan } from "./elements/createLinkWithSpan.js";
import { createSlot } from "./elements/createSlot.js";
import { createStyledSlotOrClone } from "./elements/createStyledSlotOrClone.js";
import { createStyleTemplate } from "./elements/createStyleTemplate.js";
import { createTextContainer } from "./elements/createTextContainer.js";
import { createTextWithLink } from "./elements/createTextWithLink.js";
import { createTimeElement } from "./elements/createTimeElement.js";
import { handleKeyboardNavigation } from "./events/handleKeyboardNavigation.js";
import { setupSwipeDetection } from "./events/setupSwipeDetection.js";
import { imageFromSvg } from "./media/imageFromSvg.js";
import { parseSvgString } from "./media/parseSvgString.js";
import { getResponsiveImageSize } from "./media/getResponsiveImageSize.js";
import { fetchGraphQL } from "./network/fetchGraphQL.js";
import { isExternalUrl } from "./network/isExternalUrl.js";
import { debounce } from "./performance/debounce.js";
import { FCP_THRESHOLD_GOOD, FCP_THRESHOLD_NEEDS_IMPROVEMENT, LCP_THRESHOLD_GOOD, LCP_THRESHOLD_NEEDS_IMPROVEMENT, THRESHOLDS, getFCPRating, getLCPRating, isFCPGood, isLCPGood, msToSeconds, secondsToMs } from "./performance/thresholds.js";
import { clearPerformanceMarks, getFCP, getNavigationTiming, markPerformance, measurePerformance, observeFCP, observeLCP } from "./performance/metrics.js";
import { getLocalStorageInt } from "./storage/getLocalStorageInt.js";
import { setLocalStorageTimestamp } from "./storage/setLocalStorageTimestamp.js";
import { capitalize } from "./string/capitalize.js";
import { truncate } from "./string/truncate.js";
import { truncateText } from "./string/truncateText.js";
import { truncateTextBasedOnSize } from "./string/truncateTextBasedOnSize.js";
import { combineStyles } from "./styles/combineStyles.js";
import { jssToCSS } from "./styles/jssToCSS.js";
import { jssEntryToCSS } from "./styles/jssEntryToCSS.js";
import { withViewTimelineAnimation } from "./styles/withViewTimelineAnimation.js";
import { createMediaQuery } from "./styles/createMediaQuery.js";
import { createMediaQueryRange } from "./styles/createMediaQueryRange.js";
import { parsePixelValue } from "./styles/parsePixelValue.js";
import { theme } from "./theme.js";
import { getValidatedSlotImage } from "./validation/getValidatedSlotImage.js";
import { isHTMLElement } from "./validation/isHTMLElement.js";
const VERSION = "0.1.0";
export {
  FCP_THRESHOLD_GOOD,
  FCP_THRESHOLD_NEEDS_IMPROVEMENT,
  LCP_THRESHOLD_GOOD,
  LCP_THRESHOLD_NEEDS_IMPROVEMENT,
  THRESHOLDS,
  VERSION,
  addClass,
  capitalize,
  clearPerformanceMarks,
  cloneElementWithoutAttributes,
  combineStyles,
  createEventDetails,
  createImageOrLinkedImage,
  createLinkWithSpan,
  createMediaQuery,
  createMediaQueryRange,
  createSlot,
  createStyleTemplate,
  createStyledSlotOrClone,
  createTextContainer,
  createTextWithLink,
  createTimeElement,
  debounce,
  extractIconElement,
  fetchGraphQL,
  findParent,
  formatDateForComparison,
  formatDateForDisplay,
  getFCP,
  getFCPRating,
  getImageFromSlot,
  getLCPRating,
  getLinkFromSlot,
  getLocalStorageInt,
  getNavigationTiming,
  getResponsiveImageSize,
  getValidatedSlotImage,
  handleKeyboardNavigation,
  imageFromSvg,
  imageHasAlt,
  isExternalUrl,
  isFCPGood,
  isHTMLElement,
  isLCPGood,
  isPreferredReducedMotion,
  isScreenZoomed,
  jssEntryToCSS,
  jssToCSS,
  markPerformance,
  measurePerformance,
  msToSeconds,
  observeFCP,
  observeGridAnimations,
  observeLCP,
  parseDateFromElement,
  parsePixelValue,
  parseSvgString,
  removeClass,
  secondsToMs,
  setLocalStorageTimestamp,
  setupSwipeDetection,
  shrinkThenRemove,
  smoothScrollToElement,
  theme,
  toElementVisual,
  toUMDElement,
  trapFocus,
  truncate,
  truncateText,
  truncateTextBasedOnSize,
  withViewTimelineAnimation,
  wrapLinkForAnimation,
  wrapTextNodeInSpan
};
//# sourceMappingURL=index.js.map
